import React, { useState, useEffect } from 'react';
import { Button, Col, Row, ModalBody, Form, Spinner } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import {
	addNewBreachRiskClassification,
	checkBreachRiskClassificationExists,
	updateBreachRiskClassification,
} from '../../../../../slices/breachRiskClassification/thunk';
import { setRequireCloseModal } from '../../../../../slices/breachRiskClassification/reducer';
import OInput from '../../../../../Components/OElements/OInput';

const BreachRiskClassificationForm = ({
	dataBreachRiskClassification,
	isEdit,
	handleToggleModal,
	isOpen,
	toggleRefetch,
}) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const selectorBreachRiskClassification = createSelector(
		state => state.BreachRiskClassification,
		data => ({
			isAdding: data.isAdding,
			isUpdating: data.isUpdating,
			requireCloseModal: data.requireCloseModal,
		})
	);
	const { isAdding, isUpdating, requireCloseModal } = useSelector(
		selectorBreachRiskClassification
	);

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: dataBreachRiskClassification?.name || '',
			disable: dataBreachRiskClassification?.disable || false,
		},
		validationSchema: Yup.object({
			name: Yup.string()
				.required('Campo requerido')
				.test(
					'name-exists-check',
					'Clasificación de Riesgo ya existe',
					async function (value) {
						if (
							value &&
							(!isEdit || value !== dataBreachRiskClassification?.name)
						) {
							const result = await dispatch(
								checkBreachRiskClassificationExists(value)
							);
							if (result.payload.exists) {
								return this.createError({
									message: 'Clasificación de Riesgo ya existe',
								});
							}
						}
						return true;
					}
				),
		}),
		validateOnChange: false,
		validateOnBlur: true,
		onSubmit: async values => {
			setIsLoading(true);
			try {
				const data = {
					...values,
					...(isEdit && { _id: dataBreachRiskClassification._id }),
				};
				if (isEdit) {
					await dispatch(updateBreachRiskClassification(data));
				} else {
					await dispatch(addNewBreachRiskClassification(data));
				}
			} finally {
				setIsLoading(false);
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
				if (toggleRefetch) {
					setTimeout(() => {
						toggleRefetch();
					}, 100);
				}
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={12}>
						<OInput
							name='name'
							label='Nombre de la Clasificación de Riesgo'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => handleToggleModal()}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isLoading || isAdding || isUpdating}
					>
						{isLoading || isAdding || isUpdating ? (
							<i className='label-icon'>
								<Spinner size='sm' />
							</i>
						) : (
							<i className='ri-save-3-line label-icon'></i>
						)}
						{isEdit ? 'Editar' : 'Crear'} Clasificación de Riesgo
					</button>
				</div>
			</div>
		</Form>
	);
};

export default BreachRiskClassificationForm;
